import {
  Box,
  CircularProgress,
} from '@mui/material';
import { usePurchasing } from '../../../hooks';
import EmptyState from '@shared/ui/common/EmptyState';
import ErrorState from '@shared/ui/common/ErrorState';
import { Paper } from '@shared/ui/common/paper';
import { PurchaseOrderDraftsTable } from './PurchaseOrderDraftsTable';
import { CreatePurchaseOrderFlow } from '../../create/CreatePurchaseOrderFlow';
import { useBottomSheet } from '@shared/shell/bottomsheet/useBottomSheet';

const PurchaseOrderDraftsView = () => {
  const { purchaseOrders, isLoading, error } = usePurchasing(undefined, { draft: true });
  const { openBottomSheet, closeBottomSheet } = useBottomSheet();
  if (isLoading) {
    return (
      <Paper sx={{ p: 2, minHeight: '200px', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
        <CircularProgress />
      </Paper>
    );
  }

  if (error) {
    return (
      <Paper sx={{ overflow: 'hidden' }}>
        <ErrorState error={error} />
      </Paper>
    );
  }

  if (purchaseOrders?.length === 0) {
    return (
      <Paper>
        <EmptyState
          title="Your draft list is empty"
          description="When creating a purchase order it will be saved as a draft until you send it"
          action={{
            label: 'Create purchase order',
            onClick: () => {
              openBottomSheet({
                title: 'Purchase Order Draft',
                component: <CreatePurchaseOrderFlow handleClose={closeBottomSheet} />,
              })
            }
          }}
        />
      </Paper>
    );
  }

  return (
    <Box>
      <PurchaseOrderDraftsTable drafts={purchaseOrders || []} />
    </Box>
  );
};

export default PurchaseOrderDraftsView;
